import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { submitReport } from '../api';
import PageBackground from '../components/PageBackground';
import './ThankYou.css';

export default function ThankYou() {
  const { user } = useAuth();
  const [status, setStatus] = useState('saving');

  useEffect(() => {
    sessionStorage.setItem('diwaliHuntCompleted', '1');
  }, []);

  useEffect(() => {
    if (!user) return;
    const id = sessionStorage.getItem('diwaliHuntStatId');
    submitReport({
      id,
      name: user.name,
      email: user.email,
      employeeId: user.employeeId,
      organizationId: user.organizationId,
      userId: user.userId,
      role: user.role,
    })
      .then(() => setStatus('done'))
      .catch(() => setStatus('error'));
    sessionStorage.removeItem('diwaliHuntStatId');
  }, [user]);

  return (
    <div className="thankyou-page">
      <PageBackground />
      <img src="/img/thankyou1.gif" alt="Thank you" className="thankyou-gif" />
      {status === 'error' && (
        <p className="thankyou-error">We couldn't save your report, but thanks for playing!</p>
      )}
    </div>
  );
}
